module.exports = require('./helpers/bundle-url').getBundleURL('it0sp') + "logo-dark.eefe0b7f.svg";